import React from 'react';
import Modal from '../../../../UiKit/Modal/Modal';
import NavigationButton, {NavigationButtonGroup} from '../../../../UiKit/Wizard/NavigationButton/NavigationButton'
import { useLanguage } from '../../../../UiKit/Wizard/langugeContext';
 import { translations } from '../translation';

function CloseModal({ type, onConfirm, onCancel }) {
    const { currentLanguage } = useLanguage();
    const closeTranslations = translations[currentLanguage]["closeModal"];
  
    return (
      <Modal type={type}>
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Close onClick={onCancel} />
          </Modal.Header>
          <Modal.Body>
            <Modal.Title>{closeTranslations.endLiveChat}</Modal.Title>
            <Modal.Content>
             {closeTranslations.continueWithVirtualAssistant}
            </Modal.Content>
            <NavigationButtonGroup>
              <NavigationButton style={{ marginBottom: "8px" }} type="primary" onClick={onConfirm}>
                {closeTranslations.endLiveChatButton}
              </NavigationButton>
              <NavigationButton type="secondary" onClick={onCancel}>     
               {closeTranslations.cancelButton}
              </NavigationButton>
            </NavigationButtonGroup>
          </Modal.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
  

export default CloseModal;